export const GENDER_TYPES = {
  BOYS: 'Boys',
  GIRLS: 'Girls',
  KIDS: 'Kids',
  MEN: 'Men',
  WOMEN: 'Women'
} as const;

export const VARIABLE_BIAS_GENDER_ATTRIBUTE = 'txAttrFacet_Gender';
